import endpoints from '@/utils/constants';
import { apiHelper } from '@/utils/helpers';

const actions = {
    saveServiceRequestTransaction(context, payload) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload.serviceRequestId}/transactions`, context.state.serviceRequestTransaction)
                .then(res => {
                    if (res.status === 201) {
                        resolve(res.data)
                    }
                }).catch(err => {
                    reject(err)
                })
        })
    },

    getAdvanceAmountTransaction(context, payload) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/transactions/advance`)
                .then(res => {
                    context.commit('setTransaction', res.data);
                    resolve(res.data)
                }).catch(err => {
                    reject(err)
                })
        })
    },
    getServiceRequestTransactions(context,payload) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/transactions`)
                .then(res => {
                    context.commit('setTransactionList', res.data);
                }).catch(err => {
                    reject(err)
                });
        })
    },

    updateServiceRequestTransaction(context, payload){
        if(context.state.serviceRequestTransaction.acceptedBy === '') {
            delete context.state.serviceRequestTransaction.acceptedBy;
        }
        return new Promise((resolve, reject) => {
            apiHelper.call('patch', `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/transactions/${context.state.serviceRequestTransaction.serviceRequestTransactionId}`, context.state.serviceRequestTransaction)
            .then(res => {
                context.commit('setTransaction', res.data);
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export default actions;